import { render } from "./PackageOrderForm.vue?vue&type=template&id=19c60350&scoped=true"
import script from "./PackageOrderForm.vue?vue&type=script&lang=js"
export * from "./PackageOrderForm.vue?vue&type=script&lang=js"

import "./PackageOrderForm.vue?vue&type=style&index=0&id=19c60350&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c60350"]])

export default __exports__